import { FC, useMemo } from 'react'
import { useLocation } from 'react-router'

import { appNavigation } from '@/app-navigation'
import { AnimatedTabs } from '@/components/navigation/tabs'
import { useAppSelector, useAuthSelector } from '@/store'

const DesktopNav: FC = () => {
  const { app } = useAppSelector()
  const { pathname } = useLocation()
  const { role } = useAuthSelector()

  const navItems = useMemo(
    () => (role && app && pathname !== '/' ? appNavigation(role)[app].filter(item => !item.hidden) : []),
    [app, role, pathname]
  )

  return <AnimatedTabs items={navItems} />
}

export default DesktopNav
